import { loadRuntimeConfig } from "./runtimeConfig";

async function startApplication() {
    await loadRuntimeConfig(`${import.meta.env.BASE_URL}config.json`);
    await import("./index");
}

void startApplication().catch((error: unknown) => {
    console.error("Application startup failed because the runtime configuration could not be loaded.", error);

    const root = document.getElementById("root");
    if (root) {
        root.textContent =
            "Errore nel caricamento della configurazione. Verificare config.json e ricaricare la pagina.";
    }
});
